import { Component, OnInit,  } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
export interface ProjectClosure {
  title: string;
  process: string;
  forms: string;
  actions: string;
  reporting: string;
  deliverables: string;
}

@Component({
  selector: 'app-project-closure',

  templateUrl: './project-closure.component.html',
  styleUrl: './project-closure.component.css'
})
export class ProjectClosureComponent {
closureForm: FormGroup;


  constructor(private fb: FormBuilder) {
    this.closureForm = this.fb.group({
      title: [''],
      process: [''],
      forms: [''],
      actions: [''],
      reporting: [''],
      deliverables: ['']
    });
  }

 

  addClosure() {
    const formData: ProjectClosure = this.closureForm.value;
   
  }


}

